import React, { useMemo } from 'react';
import { getQueryString, useRouter } from '@framework/router';
import { TABS } from '@/creditflowresearch/ui/components/league/LeagueTablePage/constants';
import cn from 'classnames';
import styles from '@/creditflowresearch/ui/components/league/LeagueTablePage/leagueTablePage.module.scss';
import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';
import { getLeagueTableItemRoute } from '@/creditflowresearch/ui/components/league/LeagueTablePage/helpers';

const LeagueTableTabContent = () => {
  const { query: { tab, products, regions, q } } = useRouter();
  const search = { products, regions, q };
  const tabName = Array.isArray(tab) ? tab[0] : tab;
  const currentTab = useMemo(() => TABS[tabName], [tab]);

  if (!currentTab) {
    return null;
  }

  const { columns, dataTest, components: { table: TableComponent } } = currentTab;

  return (
    <TableComponent
      containerClassName={ cn(styles.leagueTableContainer, spacesStyles.mbn) }
      rowClassName={ styles.tableRow }
      getRoutePath={ getLeagueTableItemRoute(getQueryString(search)) }
      columns={ columns }
      dataTest={ `${ dataTest }Table` }
    />
  );
};

export default LeagueTableTabContent;
